import { DocumentTextIcon } from '@heroicons/react/24/outline'
import { H2, H4, Paragraph, SmallText } from '../../components/typography/Typography'
import { certifications, type Certification } from '../../components/ui-blocks/certifications'

const CertificationBody = ({ title, pdfUrl, thumbnail }: Certification) => (
    <>
        {thumbnail ? (
            <img
                src={thumbnail}
                alt={`${title} certificate`}
                loading='lazy'
                decoding='async'
                className='w-24 shrink-0 rounded-lg border border-gray-200 object-cover object-top aspect-[3/4] lg:w-16'
            />
        ) : (
            <div className='flex size-16 items-center justify-center rounded-xl bg-gray-100'>
                <DocumentTextIcon className='size-7 text-gray-400' />
            </div>
        )}
        <div className='mt-auto flex flex-col gap-1'>
            <H4 className='lg:text-base'>{title}</H4>
            <SmallText className='tracking-[0.15em] text-gray-500 lg:text-xs'>
                {pdfUrl ? 'View PDF' : 'PDF to be added'}
            </SmallText>
        </div>
    </>
)

const CARD = 'flex w-[45%] shrink-0 snap-start min-h-52 flex-col gap-6 rounded-2xl border border-gray-200 p-5 lg:w-auto lg:shrink lg:min-h-0 lg:gap-4 lg:rounded-xl lg:p-4'

export const Certifications = () => {
    return (
        <section className='flex flex-col gap-8'>
            <div className='flex flex-col gap-4 px-4 md:px-24'>
                <SmallText className='tracking-[0.25em] text-gray-500'>Certifications</SmallText>
                <H2>Tested, rated and documented</H2>
                <Paragraph className='text-gray-600'>
                    We are fully certified to ISO 9001, ISO 14001 and ISO 45001 standards, and our products are tested to meet international quality and safety standards. Our certifications demonstrate our commitment to quality, safety and environmental responsibility.
                </Paragraph>
            </div>

            {/* Cards swipe sideways below `lg`, then settle into one row of six. */}
            <div className='ml-4 lg:ml-0 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 md:px-24 lg:grid lg:grid-cols-6 lg:gap-3 lg:overflow-visible [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
                {certifications.map(certification =>
                    certification.pdfUrl ? (
                        <a
                            key={certification.title}
                            href={certification.pdfUrl}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={`${CARD} transition-colors hover:border-gray-300 hover:bg-gray-50`}
                        >
                            <CertificationBody {...certification} />
                        </a>
                    ) : (
                        <div key={certification.title} className={CARD}>
                            <CertificationBody {...certification} />
                        </div>
                    )
                )}
            </div>
        </section>
    )
}
